<bxi-page title="{{ 'settings.title' | translate }}" [breadcrumbOptions]="breadcrumbOptions()">
  <div class="flex flex-row gap-2">
    <button bx-button size="md" type="primary" (click)="localizationService.setLanguage('en')">
      {{ 'settings.language.english' | translate }}
    </button>

    <button bx-button size="md" type="primary" (click)="localizationService.setLanguage('de')">
      {{ 'settings.language.german' | translate }}
    </button>
  </div>
</bxi-page>
